import script from "./MenuGalleryApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuGalleryApp.vue?vue&type=script&setup=true&lang=ts"

import "./MenuGalleryApp.vue?vue&type=style&index=0&id=44169cff&scoped=true&lang=scss"

import exportComponent from "/var/www/twledodo-booking-rododo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44169cff"]])

export default __exports__